<div class="instagramSection container-fluid">
  <!-- <h1 class="text-center">{{ 'Visit-Seychelles(Instagram)' | translate }}</h1> -->
  <h2 class="text-center homeHeadingSection">{{ 'Visit-Seychelles(Instagram)' | translate }}</h2>
  <!-- <h5 class="text-center">{{ 'VisitSeyDesc' | translate }}</h5> -->
  <div class="one" #one></div>
</div>
